(() => {
  document.querySelectorAll('[data-ocloser]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('.ocloser-stage');
    const menu = root.querySelector('.ocloser-menu');
    const close = root.querySelector('.ocloser-close');
    const buttons = [...root.querySelectorAll('[data-closer-open]')];
    const details = [...root.querySelectorAll('[data-closer-detail]')];
    const visited = new Set();
    const arcs = details.map(detail => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const path = document.createElementNS(svg.namespaceURI, 'path');
      svg.setAttribute('class', 'ocloser-arc');
      svg.setAttribute('aria-hidden', 'true');
      path.setAttribute('pathLength', '1');
      svg.appendChild(path);
      detail.appendChild(svg);
      return {svg, path};
    });
    function sizeArc() {
      const detail = details[index - 1], arc = arcs[index - 1];
      if (!detail || !arc) return;
      const {width, height} = detail.getBoundingClientRect();
      const radius = parseFloat(getComputedStyle(detail).borderTopLeftRadius) || 20;
      arc.svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      arc.path.setAttribute('d', `M 1 ${radius} V ${height - radius}`);
    }
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const duration = 8000;
    let selected = buttons[0], index = 1, elapsed = 0, previous = 0, frame = 0;
    let visible = false, hovered = false, keyboard = false, playing = true;

    function progress() {
      const arc = arcs[index - 1];
      if (arc) arc.path.style.strokeDashoffset = String(1 - Math.min(1, elapsed / duration));
    }
    function show(next, newCycle = false) {
      if (index) visited.add(index);
      if (newCycle) visited.clear();
      index = next;
      elapsed = 0;
      root.querySelectorAll('[data-closer-image]').forEach(el => el.setAttribute('aria-hidden', String(Number(el.dataset.closerImage) !== index)));
      buttons.forEach(el => {
        const active = Number(el.dataset.closerOpen) === index;
        el.hidden = active;
        el.classList.toggle('is-visited', visited.has(Number(el.dataset.closerOpen)));
        el.setAttribute('aria-expanded', String(active));
      });
      root.querySelectorAll('[data-closer-detail]').forEach(el => el.hidden = Number(el.dataset.closerDetail) !== index);
      close.hidden = !index;
      stage.classList.toggle('is-open', !!index);
      sizeArc();
      progress();
    }
    function running() { return playing && index && visible && !hovered && !keyboard && !document.hidden && !reduced.matches; }
    function tick(now) {
      frame = 0;
      if (!running()) { previous = 0; return; }
      if (previous) elapsed += Math.min(now - previous, 100);
      previous = now;
      if (elapsed >= duration) show(index % buttons.length + 1, index === buttons.length);
      progress();
      frame = requestAnimationFrame(tick);
    }
    function schedule() {
      if (!running()) {
        cancelAnimationFrame(frame);
        frame = 0;
        previous = 0;
      } else if (!frame) frame = requestAnimationFrame(tick);
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      selected = button;
      playing = true;
      show(Number(button.dataset.closerOpen));
      close.focus({preventScroll: true});
      schedule();
    }));
    function reset() {
      playing = false;
      show(0);
      schedule();
      selected?.focus({preventScroll: true});
    }
    close.addEventListener('click', reset);
    root.addEventListener('keydown', event => {
      keyboard = true;
      schedule();
      if (event.key === 'Escape' && !close.hidden) { event.preventDefault(); reset(); }
    });
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget)) { keyboard = false; schedule(); }
    });
    menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } });
    menu.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', schedule);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: 0.25}).observe(menu);
    new ResizeObserver(() => { sizeArc(); progress(); }).observe(menu);
    show(1, true);
  });
})();
